import { getClientId } from 'utils/getClientId'
import { Client } from 'models/Client'
import { useQuery, UseQueryOptions } from 'react-query'
import { ApiClient } from 'services/ApiClient'
import { Api } from 'types/Api'

export namespace FetchClient {
  export type Response = Client
  export type Error = Api.Error
  export type Options = UseQueryOptions<Response, Error>
}

const createKey = (clientId?: string) => ['client', { clientId }]

const queryFetcher = (clientId?: string) => () => {
  if (!clientId) return Promise.reject()

  return ApiClient.get<FetchClient.Response>(`/v1/clients/${clientId}`)
}

export const useFetchClient = (options?: FetchClient.Options) => {
  const clientId = getClientId()
  return useQuery<FetchClient.Response, FetchClient.Error>(
    createKey(clientId),
    queryFetcher(clientId),
    options
  )
}
